import post from '../postService'
import URL from '../../Constants/apiUrls'

export default async function addUpdateForm(reqData) {
  try {
    const res = await post(`${URL.addUpdateForm}`, reqData)
    return res.data
  } catch (error) {
    return error
  }
}
